import {
  getEnvironmentBackendUrl,
  getEnvironmentTvWebhookUrl,
} from "@shared/utils/misc";
import { EnvironmentType, WorkspaceType } from "@shared/types";
import SocketHandler from "@shared/services/socket/socketHandler";
import { getStoreWorkspace } from "@shared/common/utils";

export const getApiBaseUrl = () => {
  let baseUrl: string;
  if (import.meta.env.PROD) {
    baseUrl = import.meta.env.VITE_APP_API_BASE_URL || "";
  } else {
    baseUrl = getEnvironmentBackendUrl(EnvironmentType.LOCAL);
  }
  return baseUrl;
};

export const getTvWebhookBaseUrl = () => {
  let baseUrl: string;
  if (import.meta.env.PROD) {
    baseUrl = import.meta.env.VITE_APP_TV_WEBHOOK_URL || "";
  } else {
    baseUrl = getEnvironmentTvWebhookUrl(EnvironmentType.DEV);
  }
  if (baseUrl && !baseUrl.endsWith("/")) baseUrl = baseUrl + "/";
  const workspace = getStoreWorkspace();
  if (baseUrl && workspace === WorkspaceType.DEMO) {
    baseUrl = baseUrl.replace("/tradingview/", "/tradingview-demo/");
  }
  return baseUrl;
};

export const getTradingViewApiBaseUrl = () => {
  let baseUrl: string;
  if (import.meta.env.PROD) {
    baseUrl = import.meta.env.VITE_APP_TV_API_BASE_URL || "";
  } else {
    baseUrl = getApiBaseUrl();
  }
  return baseUrl;
};

export const injectTemplateScripts = (env?: string) => {
  if (env !== "production") return;
  const gtmScript = document.createElement("script");
  gtmScript.innerHTML = `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
              new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','GTM-P5X7LQL');
  `;
  const hotjarScript = document.createElement("script");
  hotjarScript.innerHTML = `
    (function(h,o,t,j,a,r){
      h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
      h._hjSettings={hjid:2952032,hjsv:6};
      a=o.getElementsByTagName('head')[0];
      r=o.createElement('script');r.async=1;
      r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
      a.appendChild(r);
    })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
`;
  const appHead = document.getElementById("appHead");
  appHead?.appendChild(gtmScript);
  appHead?.appendChild(hotjarScript);

  const gtmNoScript = document.createElement("noscript");
  gtmNoScript.innerHTML = `
    <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-P5X7LQL"
            height="0" width="0" style="display:none;visibility:hidden">            
    </iframe>
  `;
  const appBody = document.getElementById("appBody");
  appBody?.appendChild(gtmNoScript);
};

const getWebSocketUrl = () => {
  if (`${import.meta.env.VITE_APP_WS_API_BASE_URL}`) {
    return import.meta.env.VITE_APP_WS_API_BASE_URL;
  }
  return "";
};

export const socketHandler = new SocketHandler({ url: getWebSocketUrl() });
